import logo from 'assets/images/geng_logo.svg';
import logoPayoff from 'assets/images/geng_logo_payoff.svg';
import favicon from 'assets/images/fcgp_favicon.png';
import favicon16 from 'assets/images/fcgp_favicon-16x16.png';

import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:fb920a6f-224b-46fc-8580-b91016091dfd',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_gM6CUBtow',
  aws_user_pools_web_client_id: '4gc87nln3qfv2kvehksiidigt3',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: '8',
    passwordPolicyCharacters: ['REQUIRES_NUMBERS'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint:
    'https://uc4toik4hzekra276ljbqwsolq.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://rtl30k1a5b.execute-api.eu-west-1.amazonaws.com/fcgp',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage195457-fcgp',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  aws_cognito_login_mechanisms: ['EMAIL'],
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'fcgp.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'Gen en Geneesmiddel',
  APP_CODE: 'CLIN-APP-0020',
  ENABLE_ARTICLES: true,
  ENABLE_CARDS: true,
  ENABLE_MEDICAL_PROFILE: false,
  ENABLE_MANAGEMENT: true,
  ENABLE_CLINICARDS: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_ORGANISATION_DETAILS: true,
  ENABLE_INSIGHTS: false,
  ENABLE_ORGANISATION_MULTIPLE: true,
  ENABLE_PERMISSIONS: true,
  ENABLE_OPERATION_PROFILE: true,
  AWS,
  defaultCarepathCards,
  logo,
  logoPayoff,
  favicon,
  favicon16,
};
